<template lang="pug">
.chart-view
  canvas(ref='canvas', :height='height', :width='width')
</template>

<script>
import Chart from 'chart.js'
import colors from './colors'

export default{
  props: {
    data: Object,
    options: Object,
    type: String,
    width: Number,
    height: { type: Number, default: 400 },
    shows: Array,
    updateColors: { type: Boolean, default: false },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.renderChart(this.type, this.data, this.options)
    this.updateShows()
  },
  watch: {
    shows: {
      deep: true,
      handler() {
        this.updateShows()
      },
    },
  },
  methods: {
    updateShows() {
      const length = this.chart.data.datasets.length
      let colorIndex = 0
      for (let i = 0; i < length; i++) {
        const meta = this.chart.getDatasetMeta(i)
        const data = this.chart.data.datasets[i]
        if (meta) {
          let hide = false
          if (this.shows && Array.isArray(this.shows))
            hide = !this.shows.includes(data.key)
          meta.hidden = hide
          if (this.updateColors)
            data.borderColor = data.backgroundColor = hide ? null : colors[colorIndex++]
        }
      }
      this.chart.update()
    },
    renderChart(type, data, options) {
      this.chart = new Chart(this.$refs.canvas, {
        type,
        data,
        options,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// Chart.vue?56087ace